import { DefaultState } from '@src/redux/types'

import {
  ASSESSMENT_OFFENCE,
  ASSESSMENT_OFFENCE_ALL,
  ASSESSMENT_OFFENCE_CHANGE_STATUS,
  ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS,
  ASSESSMENT_OFFENCE_INVIGILATION,
  ASSESSMENT_OFFENCE_INVIGILATION_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS,
  ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES,
  ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL,
  ASSESSMENT_OFFENCE_REPORT_ALL,
  ASSESSMENT_OFFENCE_REPORT_CREATE,
  ASSESSMENT_OFFENCE_REPORT_LIST,
  ASSESSMENT_OFFENCE_TYPE,
  ASSESSMENT_OFFENCE_TYPE_ALL,
  REPORT_MISCONDUCT,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ data: null, loading: false, error: null })

export const initialState: () => {
  [ASSESSMENT_OFFENCE]: DefaultState<`/${typeof API.OFFENCE}`, 'get'>
  [ASSESSMENT_OFFENCE_ALL]: DefaultState<`/${typeof API.OFFENCE_ALL}`, 'get'>
  [ASSESSMENT_OFFENCE_CHANGE_STATUS]: DefaultState<`/${typeof API.OFFENCE_CHANGE_STATUS}`, 'put'>
  [ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS]: DefaultState<
    `${typeof API.OFFENCE_CHANGE_SUBJECT_BOARD_STATUS}`,
    'put'
  >
  [ASSESSMENT_OFFENCE_INVIGILATION]: DefaultState<`/${typeof API.OFFENCE_INVIGILATION}`, 'get'>
  [ASSESSMENT_OFFENCE_INVIGILATION_ALL]: DefaultState<`/${typeof API.OFFENCE_INVIGILATION_ALL}`, 'get'>
  [ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS]: DefaultState<
    `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS}`,
    'get'
  >
  [ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL]: DefaultState<
    `/${typeof API.OFFENCE_INVIGILATION_CONSULTATIONS_ALL}`,
    'get'
  >
  [ASSESSMENT_OFFENCE_INVIGILATION_MINUTES]: DefaultState<`/${typeof API.OFFENCE_INVIGILATION_MINUTES}`, 'get'>
  [ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL]: DefaultState<`/${typeof API.OFFENCE_INVIGILATION_MINUTES_ALL}`, 'get'>
  [ASSESSMENT_OFFENCE_REPORT_ALL]: DefaultState<`/${typeof API.OFFENCE_REPORT_ALL}`, 'get'>
  [ASSESSMENT_OFFENCE_REPORT_CREATE]: DefaultState<`/${typeof API.OFFENCE_REPORT}`, 'post'>
  [ASSESSMENT_OFFENCE_REPORT_LIST]: DefaultState<`/${typeof API.OFFENCE_REPORT}`, 'get'>
  [ASSESSMENT_OFFENCE_TYPE]: DefaultState<`/${typeof API.OFFENCE_TYPE}`, 'get'>
  [ASSESSMENT_OFFENCE_TYPE_ALL]: DefaultState<`/${typeof API.OFFENCE_TYPE_ALL}`, 'get'>
  [REPORT_MISCONDUCT]: DefaultState<`${typeof API.REPORT_MISCONDUCT}`, 'post'>
} = () => ({
  [ASSESSMENT_OFFENCE]: defaultState(),
  [ASSESSMENT_OFFENCE_ALL]: defaultState(),
  [ASSESSMENT_OFFENCE_CHANGE_STATUS]: defaultState(),
  [ASSESSMENT_OFFENCE_CHANGE_SUBJECT_BOARD_STATUS]: defaultState(),
  [ASSESSMENT_OFFENCE_INVIGILATION]: defaultState(),
  [ASSESSMENT_OFFENCE_INVIGILATION_ALL]: defaultState(),
  [ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS]: defaultState(),
  [ASSESSMENT_OFFENCE_INVIGILATION_CONSULTATIONS_ALL]: defaultState(),
  [ASSESSMENT_OFFENCE_INVIGILATION_MINUTES]: defaultState(),
  [ASSESSMENT_OFFENCE_INVIGILATION_MINUTES_ALL]: defaultState(),
  [ASSESSMENT_OFFENCE_REPORT_ALL]: defaultState(),
  [ASSESSMENT_OFFENCE_REPORT_CREATE]: defaultState(),
  [ASSESSMENT_OFFENCE_REPORT_LIST]: defaultState(),
  [ASSESSMENT_OFFENCE_TYPE]: defaultState(),
  [ASSESSMENT_OFFENCE_TYPE_ALL]: defaultState(),
  [REPORT_MISCONDUCT]: defaultState(),
})
